import { ShipmentType } from '@/types/ShipmentType';

export const isShipmentInternational = (
  shipment_type: ShipmentType | undefined
) => {
  return shipment_type ? shipment_type.includes('INTERNATIONAL_') : false;
};
